import { createContext } from "react";
import { Techpack, TechpackItem, TechpackItemArtwork } from "../../../types";

type AdminTechpackContextType = {
  teckpackDetails?: Techpack | null;
  updateTechpackItemArtwork: (
    techpackItemId: string,
    techpackItemArtwork: TechpackItemArtwork
  ) => void;
  updateTechpack: (techpack: Techpack) => void;
  updateTechpackItem: (techpackItem: TechpackItem) => void;
  isTeckpackLoaded: boolean;
  refetchTechpack: () => void;
};

export const AdminTechpackContext = createContext<AdminTechpackContextType>({
  teckpackDetails: null,
  updateTechpackItemArtwork: () => {},
  updateTechpack: () => {},
  updateTechpackItem: () => {},
  isTeckpackLoaded: false,
  refetchTechpack: () => {},
});
